import { useEffect } from "react";

export function useReportDirty(
  isDirty: boolean,
  setIsDirty: (isDirty: boolean) => void,
) {
  useEffect(() => {
    setIsDirty(isDirty);
  }, [isDirty, setIsDirty]);
}
